window.App = {
  mutation_observers: [],
  is_ios_mobile_device: /client:ios/.test(navigator.userAgent),
  is_android_mobile_device: /client:android/.test(navigator.userAgent),
  ...window.App,
};
